import { createGlobalStyle } from 'styled-components';

export const GlobalParentButtonStyle = createGlobalStyle`
    .bt {
        display: inline-block;
        border-radius: ${props => props.theme.buttonBorderRadius};
        font-size: ${props => props.theme.buttonFontSize};
        font-weight: ${props => props.theme.buttonFontWright};
        padding: 14px 22px;
        line-height: 1;
        text-decoration: none;
        transition: opacity 0.2s ease-out;
        border-width: 1px;
        border-style: solid;
        outline: 0;
        cursor: pointer;
        text-align: center;
        text-transform: ${props => props.theme.buttonFontStyle};
    }
    .bt:hover {
        opacity: 0.8;
    }
    .bt-main {
        background-color: ${props => props.theme.buttonMainBg};
        color: ${props => props.theme.buttonMainText};
        border-color: ${props => props.theme.buttonMainBorder};
            &:hover {
            background-color: ${props => props.theme.buttonMainHoverBg};
            color: ${props => props.theme.buttonMainHoverText};
            border-color: ${props => props.theme.buttonMainHoverBorder};
        }
    }
    .bt-second {
        background-color: ${props => props.theme.buttonSecondBg};
        color: ${props => props.theme.buttonSecondText};
        border-color: ${props => props.theme.buttonSecondBorder};
    }
    .bt-third {
        background-color: ${props => props.theme.buttonThirdBg};
        color: ${props => props.theme.buttonThirdText};
        border-color: ${props => props.theme.buttonThirdBorder};
    }
    .bt-fourth {
        background-color: ${props => props.theme.buttonFourthBg};
        color: ${props => props.theme.buttonFourthText};
        border-color: ${props => props.theme.buttonFourthBorder};
    }
    .bt-fifth {
        background-color: ${props => props.theme.buttonFifthBg};
        color: ${props => props.theme.buttonFifthText};
        border-color: ${props => props.theme.buttonFifthBorder};
    }
    .bt-sixth {
        background-color: ${props => props.theme.buttonSixthBg};
        color: ${props => props.theme.buttonSixthText};
        border-color: ${props => props.theme.buttonSixthBorder};
    }
`;



// WEBPACK FOOTER //
// ./src/components/button/ParentButtonComponentStyle.js